import {locationChange} from '../../ducks/duck-router';
import {removeModalWindow} from '../../ducks/duck-screen'

let lastPathname;
export function initHistoryListener(history, store) {
	lastPathname = history.location.pathname;
	store.dispatch(
		locationChange(history.location.pathname)
	);

	history.listen((location, action) => {
		const state = store.getState();
		const modalList = state.screenReducer.modalList;

		/* Jeżeli na ekranie jest pokazany jakiś modal i użytkownik cofa strone */
		if(modalList.length > 0 && action === 'POP'){
			//usuwamy modal
			store.dispatch(removeModalWindow());
			//pushujemy strone spowrotem na stack
			history.push(lastPathname);
			return
		}

		store.dispatch(
			locationChange(location.pathname)
		);

		lastPathname = location.pathname;
	});
}
